import { Box } from "grommet";
import React from "react";
import { useTitle } from "react-use";
// import * as r from "../../routes";
import "./Transactions.scss";

interface TransactionsProps {}

const Transactions: React.FC<TransactionsProps> = () => {
  useTitle("Transactions | Due");
  // const dispatch = useDispatch();
  // const { accounts, loading } = useAccounts();

  return (
    <Box
      align="start"
      direction="row"
      width="1150px"
      gap="medium"
      pad={{ top: "small" }}
    ></Box>
  );
};

export default Transactions;
